import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { getAccountInfoAsync } from "../../services/accountService";
import { IoCloudUploadOutline } from "react-icons/io5";
import ProfileHeading from "../Profile/components/ProfileHeading";
import TextboxSearch from "../../components/common/TextboxSearch";
import DocumentsTable from "./components/DocumentsTable";
import Modal from "../../components/common/Modal";
import DocumentForm from "./components/DocumentForm";

const AccountDocuments = () => {
  const { id } = useParams();

  const [account, setAccount] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    search_query: "",
    current_page: 1,
    page_size: 10,
    sort_column: { path: "uploaded_on", order: "desc" },
  });

  const columns = [
    { path: "document_name", label: "Document Name" },
    { path: "uploaded_on", label: "Date Uploaded" },
  ];

  const handleOptionsChange = (options) => setTableOptions(options);

  const handleSearch = (query) => {
    const options = { ...tableOptions };

    if (options.search_query !== query) {
      options.search_query = query;
      options.current_page = 1;
      handleOptionsChange(options);
    }
  };

  useEffect(() => {
    let mounted = true;

    const fetchAccount = async () => {
      setIsLoading(true);
      const result = await getAccountInfoAsync(id);
      if (result === null) return window.location("/404");

      if (mounted) {
        setAccount(result);
        setIsLoading(false);
      }
    };

    fetchAccount();

    return () => {
      mounted = false;
    };
  }, [id]);

  const handleSuccess = () => {
    const options = { ...tableOptions };
    handleOptionsChange(options);
    setShowForm(false);
  };

  return (
    <div className="mt-2">
      <div className="max-w-7xl mx-auto px-6 lg:px-0">
        <div className="grid grid-cols-2 gap-5">
          <div className="col-span-2">
            <div className="card p-6">
              <ProfileHeading data={account} isLoading={isLoading} />
            </div>
          </div>
          <div className="col-span-2">
            <div className="card p-8">
              <div className="block sm:flex justify-between items-center">
                <div>
                  <p className="text-gray-400 text-sm">Account Documents</p>
                  <span className="text-gray-400 text-xs">
                    List of Uploaded Documents
                  </span>
                </div>
                <div className="mt-5 sm:mt-0">
                  <button
                    className="button button-primary"
                    onClick={() => setShowForm(true)}
                  >
                    <IoCloudUploadOutline className="mr-2" />
                    Upload Documents
                  </button>
                </div>
              </div>
              <div className="block sm:justify-between items-center mt-8">
                <TextboxSearch
                  placeholder="Search..."
                  onSearch={handleSearch}
                />
              </div>
              <div className="mt-8">
                <DocumentsTable
                  id={id}
                  columns={columns}
                  tableOptions={tableOptions}
                  onChange={handleOptionsChange}
                />
              </div>
              <Modal
                size="md"
                title="Upload Documents"
                isOpen={showForm}
                isLoading={isFormLoading}
                onClose={() => setShowForm(false)}
                borderTop
              >
                <DocumentForm
                  id={id}
                  isLoading={isFormLoading}
                  setLoading={setIsFormLoading}
                  onSuccess={handleSuccess}
                />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDocuments;
